import Container from "./Container";

function Section({
  children,
  id,
  className = "",
  containerClassName = "",
  as: Component = "section",
  tone = "default"
}) {
  const toneMap = {
    default: "bg-transparent",
    white: "bg-white",
    muted: "bg-gradient-to-b from-[#F8FAFF] to-white",
    elevated: "bg-white",
    dark: "bg-brand-navy-deep text-brand-ivory"
  };

  const toneClass = toneMap[tone] || toneMap.default;

  return (
    <Component
      id={id}
      className={`relative py-20 sm:py-24 lg:py-28 ${toneClass} ${className}`.trim()}
    >
      <Container className={containerClassName}>{children}</Container>
    </Component>
  );
}

export default Section;
